import {omit} from 'lodash'
import {subdomainLink} from '../../../helpers/url'
import React from 'react'
import {Link} from 'react-router-dom'
import {Consumer} from '../../../context'
import Icon from '../../icon'

function LessonLink (props) {
  const {key, enabled, to, title, href} = props
  const linkProps = omit(props, ['key', 'enabled'])
  const LinkElem = to
    ? Link
    : ({children}) => (<a {...linkProps}>{children}</a>)
  return (
  <div key={key} className={key}>
    {enabled && (
      <LinkElem {...linkProps}>
        <Icon name={key} />
      </LinkElem>
    )}
    {!enabled && (
      <div className="disabled">
        <Icon name={key} />
      </div>
    )}
  </div>)
}

export default function UploadLinks (props) {
  const {name, id, assigned} = props
  return (<Consumer>{ context => {
    const {link, match, translations, languageId, profile} = context
    const {limited} = profile.institution
    const tooltipTitle = (name) => `${translations[`${name}_tooltip_title`][languageId]}: ${props.name}`
    const links = [
      { key: 'download',
        title: tooltipTitle('download'),
        enabled: !limited,
        href: subdomainLink('download', profile.domain, profile.Passport.userName, 'lesson', name),
        target: "blank"}
    ]
    return (
      <div className="links">
        {links.map(LessonLink)}
      </div>
    )
  }}</Consumer>)
}
